import { render, staticRenderFns } from "./department-alone-list.vue?vue&type=template&id=0acbf50c&scoped=true&"
import script from "./department-alone-list.vue?vue&type=script&lang=js&"
export * from "./department-alone-list.vue?vue&type=script&lang=js&"
import style0 from "./department-alone-list.vue?vue&type=style&index=0&id=0acbf50c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbf50c",
  null
  
)

export default component.exports